import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["testId"];
import React, { useMemo } from 'react';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import LegacyWarningIcon from '@atlaskit/icon/glyph/warning';
import { fg } from '@atlaskit/platform-feature-flags';
import { R300 } from '@atlaskit/theme/colors';
import { messages } from '../../../messages';
import Text from '../../FlexibleCard/components/elements/text';
import { RetryAction } from '../actions/RetryAction';
import UnresolvedView from './unresolved-view';
import { withFlexibleUIBlockCardStyle } from './utils/withFlexibleUIBlockCardStyle';

/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */
var ErroredView = function ErroredView(_ref) {
  var _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-block-errored-view' : _ref$testId,
    props = _objectWithoutProperties(_ref, _excluded);
  var actions = useMemo(function () {
    return props.onAuthorize ? [RetryAction(props.onAuthorize)] : [];
  }, [props.onAuthorize]);
  return /*#__PURE__*/React.createElement(UnresolvedView, _extends({}, props, {
    actions: actions,
    testId: testId
  }), fg('platform-smart-card-icon-migration') ? /*#__PURE__*/React.createElement(WarningIcon, {
    label: "errored-warning-icon",
    color: "var(--ds-icon-warning, #E56910)",
    LEGACY_size: "small",
    testId: "".concat(testId, "-warning-icon")
  }) :
  /*#__PURE__*/
  // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19497
  React.createElement(LegacyWarningIcon, {
    label: "errored-warning-icon",
    size: "small",
    primaryColor: "var(--ds-icon-warning, ".concat(R300, ")"),
    testId: "".concat(testId, "-warning-icon")
  }), /*#__PURE__*/React.createElement(Text, {
    maxLines: 3,
    message: {
      descriptor: messages.could_not_load_link
    }
  }));
};
export default withFlexibleUIBlockCardStyle(ErroredView);